import { IModel, IViolation } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { AzureKeyVault } from '../linkedservice/key-vault';
import { CredentialProperties } from './credential-properties';
import { azureCloudTypeDef } from '../../constants/linkedservice-constants';
import { ModelConstants } from '../model-constants';
import { FederatedIdentityCredentialProperties } from './federated-identity-credential-properties';

@Metamodel.model({
    name: ModelConstants.servicePrincipalCredentialProperties,
    display: [shellStringResources.ModelName_ServicePrincipalCredentialProperties]
})
export class ServicePrincipalCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AzureCloudType
    })
    public azureCloudType?: azureCloudTypeDef;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Tenant
    })
    public tenant: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalAuthority?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalKey,
        constraint: {
            required: true,
            validator: (_spnCredProperties: ServicePrincipalCredentialProperties, referencedResource: AzureKeyVault | FederatedIdentityCredentialProperties): IViolation[] | undefined => {
                if (referencedResource instanceof AzureKeyVault && referencedResource.storageLinkedService == null) {
                    return [{ message: () => shellStringResources.Error_InvalidAKVLSReferenced }];
                }
                return undefined;
            }
        }
    })
    public servicePrincipalKey: AzureKeyVault | FederatedIdentityCredentialProperties;
}
